var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CurrencySmart"},[_c('Currency',{attrs:{"id":_vm.id,"quantity":_vm.quantity,"showPosNeg":_vm.showPosNeg,"imageUrl":_vm.imageUrl,"name":_vm.name,"description":_vm.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }